<template>
  <section class="home">
    <h4>Bonjour 👋</h4>
    <p class="welcome-message">
      Quelle est la raison de votre visite aujourd'hui ?
    </p>
  </section>
</template>

<script>
export default { name: "Home" }
</script>

<style lang="scss" scoped>
.home {
  padding: 24px 16px;

  h4 {
    margin-bottom: 6px;
    font-weight: normal;
  }

  .welcome-message {
    font-size: 13px;
    padding: 0;
    margin: 0;
  }
}
</style>